import React, { Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./MapMarker.scss";

const MapMarker = props => {
	const { $hover, highlighted, title, message, type } = props;

	return (
		<Fragment>
			<div
				className={classNames(`mapmarker ${type}-marker`, { hovered: $hover, highlighted })}
			/>
			<If condition={(title || message) && $hover}>
				<div className="marker-info">
					{title && <strong>{title}</strong>}
					<br className={title && message ? "" : "hidden"} />
					{message}
				</div>
			</If>
		</Fragment>
	);
};

MapMarker.propTypes = {
	$hover: PropTypes.bool,
	highlighted: PropTypes.bool,
	title: PropTypes.string,
	message: PropTypes.string,
	type: PropTypes.string,
};

MapMarker.defaultProps = {
	$hover: false,
	highlighted: false,
	title: "",
	message: "",
	type: "job",
};

export default MapMarker;
